<div class="container" style="display: flex; height: 100%;">
    <div class="flex items-center">
        <div class="sm:w-full md:w-1/2 lg:w-1/2">
            <img decoding="async" width="900" height="560"
                src="https://jamestown.edu.co/wp-content/uploads/2022/09/foto-perfil.png"
                class="attachment-full size-full" alt="" loading="lazy"
                srcset="https://jamestown.edu.co/wp-content/uploads/2022/09/foto-perfil.png 900w, https://jamestown.edu.co/wp-content/uploads/2022/09/foto-perfil-300x187.png 300w, https://jamestown.edu.co/wp-content/uploads/2022/09/foto-perfil-768x478.png 768w"
                sizes="(max-width: 900px) 100vw, 900px">

        </div>
        <div class="sm:w-full md:w-1/2 lg:w-1/2">
            <div class="grid grid-cols-1">
                <div>
                    <div class="elementor-icon-box-content">
                        <h3 class="elementor-icon-box-title">
                            <span>
                                Well done! You have finished your quiz. </span>
                        </h3>
                        <p class="elementor-icon-box-description">
                            Now click in the following boxes</p>
                    </div>
                </div>
                <div >
                    <div class="flex-layout">
                        <div class="card">
                            <div class="front container">
                                <div class="grid grid-cols-1 flex-card">
                                    <div class="text-center">
                                        <mat-icon
                                            style="color: #6d1f28; font-size:50px !important; width: fit-content;">sentiment_very_satisfied</mat-icon>
                                    </div>
                                    <h3 >
                                        If you passed!
                                    </h3>
                                    <div >
                                        Click here
                                    </div>
                                </div>
                            </div>
                            <div class="back container">
                                <div class="grid grid-cols-1 text-center flex-card">

                                    <h3 >
                                        If you passed!
                                    </h3>
                                    <div >
                                        <br><strong>Go back to the Jamestown platform </strong><br><br>Program
                                        the grammar class
                                        from
                                        the next
                                        unit, and continue with your program<br><br><strong>Here are some videos
                                            for you to remember
                                            how
                                            to
                                            program your classes.</strong><br>
                                        <br>
                                        <li>How to program through
                                            <a class="link-app" href="https://www.youtube.com/watch?v=N_AuzN4SglU">
                                                the web.
                                            </a>
                                            <br>
                                        </li>
                                        <li>How to program through
                                            <a class="link-app"
                                                href="https://www.youtube.com/watch?v=i6N5utXwqxM&amp;feature=emb_logo">
                                                the app.
                                            </a>
                                            <br>
                                        </li>
                                    </div>
                                    <div>
                                        <a class="button-link" href="https://app.easy-hub.co/" target="_blank">
                                            Program the grammar class
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="front container">
                                <div class="grid grid-cols-1 flex-card">
                                    <div class="text-center">
                                        <mat-icon
                                            style="color: #6d1f28; font-size:50px !important; width: fit-content;">sentiment_very_dissatisfied</mat-icon>
                                    </div>
                                    <h3>
                                        If you flunked!
                                    </h3>
                                    <div >
                                        Click here
                                    </div>
                                </div>
                            </div>
                            <div class="back container">
                                <div class="grid grid-cols-1 text-center flex-card">
                                    <h3 >
                                        If you flunked!
                                    </h3>
                                    <div >
                                        <br><strong> Practice makes perfection!</strong><br><br>So you have to
                                        practice the grammar
                                        topics as much as you can.<br><br><strong>Remember you can review using
                                            the recorded classes
                                            in
                                            the Jamestown platform.</strong><br>
                                        <br>
                                        <br>Prepare to take the quiz once more.<br>
                                    </div>
                                    <div>
                                        <a class="button-link" href="https://app.easy-hub.co/" target="_blank">
                                            Go back to the Jamestown platform
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
